export const iconFontAwesomeTimeBell = (
	<i className="fa-solid fa-bell"></i>
);
